var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './HelpValidation.module.scss';
import classNames from 'classnames';
import { CorrectIcon, ErrorIcon } from '../../../../helpers/icons';
var Success = function (_a) {
    var libraryName = _a.libraryName;
    return (_jsxs("div", __assign({ className: classNames(styles.helperContainer, styles.successBorder) }, { children: [_jsxs("div", __assign({ className: styles.errorSuccess }, { children: [_jsx(CorrectIcon, {}), libraryName, " was applied"] })), _jsx("div", __assign({ className: styles.description }, { children: "Enjoy your ultimative GTO tool!" }))] })));
};
var Error = function (_a) {
    var type = _a.type;
    return (_jsxs("div", __assign({ className: classNames(styles.helperContainer, styles.errorBorder) }, { children: [_jsxs("div", __assign({ className: styles.errorTitle }, { children: [_jsx(ErrorIcon, {}), type ? "Key doesn't exist" : 'Invalid format'] })), _jsx("div", __assign({ className: styles.description }, { children: type }))] })));
};
var Empty = function () {
    return _jsx("div", { className: styles.helperContainer });
};
export var HelpValidation = function (_a) {
    var isError = _a.isError, isApply = _a.isApply, keyText = _a.keyText;
    if (isApply) {
        if (keyText === (isApply === null || isApply === void 0 ? void 0 : isApply.key)) {
            return (isApply === null || isApply === void 0 ? void 0 : isApply.error) ? _jsx(Error, { type: isApply.error }) : _jsx(Success, { libraryName: isApply.license_name });
        }
        return _jsx(Empty, {});
    }
    return isError ? _jsx(Error, { type: 'The key must contains 24 character' }) : _jsx(Empty, {});
};
